import { NgModule } from '@angular/core';
/**
 * Created by christophe on 28/04/17.
 */

@NgModule({})
export class AuthModule {
    constructor() {
        // Get google oAuth token
        if (window.location.href.indexOf('access_token') !== -1) {
            let indexStart =
                window.location.href.indexOf('id_token=') + 'id_token='.length;
            let indexEnd = window.location.href.indexOf('&', indexStart);
            if (indexEnd === -1) {
                indexEnd = window.location.href.length;
            }
            let token = window.location.href.slice(indexStart, indexEnd);
            localStorage.setItem('authenticationToken', token);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.module.ts